module.exports = __webpack_public_path__ + "static/img/pinterest.d524d2f0.png";